import { MenuItem } from '@mui/material'
import { DenyWithCommentTaskDialog } from 'components/pages/task/details/task-content-v2/common/DenyWithCommentTaskDialog'
import { TaskValue } from 'lib/actions/task'
import { useSimpleModal } from 'lib/modals'
import { FC } from 'react'
import { useIntl } from 'react-intl'

type DenyWithCommentDropdownOptionProps = {
    task: TaskValue
    close: () => void
}

export const DenyWithCommentDropdownOption: FC<DenyWithCommentDropdownOptionProps> = ({ task, close }) => {
    const intl = useIntl()
    const { open } = useSimpleModal()
    const handleClick = (): void => {
        open(DenyWithCommentTaskDialog, { task })()
        close()
    }

    let label: string
    switch (task.type?.taskType.oneofKind) {
        case 'revoke':
            label = intl.formatMessage({
                id: 'component_task_list_cancel_comment_option_label',
                defaultMessage: 'Decline with comment',
            })
            break
        case 'certify':
        case 'grant':
        default:
            // This is more generic
            label = intl.formatMessage({
                id: 'component_task_list_deny_comment_option_label',
                defaultMessage: 'Deny with comment',
            })
            break
    }

    return (
        <MenuItem onClick={handleClick} key={`components_task_actions_dropdown_deny_with_comment_task_${task.id}`}>
            {label}
        </MenuItem>
    )
}
